import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ACTION_LOGOUT, ACTION_OPEN_ACCOUNT_MENU } from "../../shared/constants";
import { signOff } from "../../shared/api";
import {USER_SUPERADMIN} from "../../shared/constants";
import { DropDownButton } from "@progress/kendo-react-buttons";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const UserMenu = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "authorizationToken"])
  );

  const currentUser = useSelector((state) => state.dataStore.get("currentUser"));
  const authorization = useSelector((state) =>
      state.dataStore.getIn(["currentUser", "authorization"])
  );


  const logout = () => {
    signOff(token);
    dispatch({
      type: ACTION_LOGOUT,
    });

    setTimeout(() => {
      sessionStorage.clear();
      history.push("/");
    }, 100);
  };

  const goToSettings = () => {
    history.push("/settings");
  }

  const openAccountModal = () => {
    dispatch({
      type: ACTION_OPEN_ACCOUNT_MENU,
      value: true
    });
  };

  const getUserMenuOptions = () => {

    if (authorization === USER_SUPERADMIN) {
      return [
          "Account",
          "Settings",
          "Log Out"
      ];
    }

    return [
      "Account",
      "Log Out",
    ];
  }

  const items = getUserMenuOptions();

  const handleClickDropDown = (e) => {
    switch (e.item) {
      case "Log Out":
        logout();
        break;
      case "Settings":
        goToSettings();
        break;
      case "Account":
        openAccountModal();
      default:
        break;
    }
  }


  return (
      <DropDownButton
      className={"dropdown-usermenu"}
      text={<>{currentUser.getIn(['name']).toUpperCase()} <ArrowDropDownIcon /> </>}
      items={items}
      onItemClick={handleClickDropDown} />
  );
};

export default UserMenu;
